const ChatIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="2"
        fill="var(--primaryLight)"
      />
      <path
        d="M12 5C8.13129 5 5 8.13075 5 12C5 13.2278 5.32022 14.427 5.9283 15.4846L5.02638 18.2854C4.96347 18.4807 5.01517 18.6947 5.16022 18.8398C5.30388 18.9834 5.5174 19.0371 5.71457 18.9736L8.51538 18.0717C9.57303 18.6798 10.7722 19 12 19C15.8687 19 19 15.8692 19 12C19 8.13129 15.8692 5 12 5ZM12 17.9062C10.891 17.9062 9.80994 17.5968 8.87373 17.0114C8.73904 16.9272 8.57178 16.9045 8.41615 16.9546L6.39432 17.6057L7.04544 15.5838C7.09479 15.4305 7.07396 15.263 6.98851 15.1263C6.40318 14.1901 6.09375 13.109 6.09375 12C6.09375 8.74332 8.74332 6.09375 12 6.09375C15.2567 6.09375 17.9062 8.74332 17.9062 12C17.9062 15.2567 15.2567 17.9062 12 17.9062ZM12.6836 12C12.6836 12.3775 12.3776 12.6836 12 12.6836C11.6224 12.6836 11.3164 12.3775 11.3164 12C11.3164 11.6224 11.6224 11.3164 12 11.3164C12.3776 11.3164 12.6836 11.6224 12.6836 12ZM15.418 12C15.418 12.3775 15.112 12.6836 14.7344 12.6836C14.3568 12.6836 14.0508 12.3775 14.0508 12C14.0508 11.6224 14.3568 11.3164 14.7344 11.3164C15.112 11.3164 15.418 11.6224 15.418 12ZM9.94922 12C9.94922 12.3775 9.6432 12.6836 9.26562 12.6836C8.88815 12.6836 8.58203 12.3775 8.58203 12C8.58203 11.6224 8.88815 11.3164 9.26562 11.3164C9.6432 11.3164 9.94922 11.6224 9.94922 12Z"
        fill="var(--primary)"
      />
    </svg>
  );
};

export default ChatIcon;
